import { useRedux } from "hooks";
import { WorkPlaceCatFilter, WorkPlaceTagFilter, WpSliceData } from "../../../redux/workplace/wpTypes";
import { createSelector } from "reselect";

interface WorkplaceFilterSelProps {
  // filterSel: WorkPlaceFilterSel[];
  onFilterDel: (tagId: number) => void;
  allTags: WorkPlaceCatFilter[];
}

const WorkplaceFilterSel = ({ allTags, onFilterDel }: WorkplaceFilterSelProps) => {
  const { dispatch, useAppSelector } = useRedux();

  const storeData = createSelector(
    (state: any) => state.WpSlice,
    (wp: WpSliceData) => ({
      tagFilterSelected: wp.tagFilterSelected,
    })
  );
  // Inside your component
  const { tagFilterSelected } = useAppSelector(storeData);
  // console.log('tagFilterSelected:', tagFilterSelected);

  const selTags = allTags.flatMap(cat => (cat.tags ?? []).filter(tag => tag.selected))
  return (
    <div className="accordion-body position-relative ps-1 pb-1 " style={{ paddingTop: "0px", fontSize: "0.95em"/*, minHeight:"30px"*/ }}>
      {/* {allTags.map((cat: WorkPlaceCatFilter, index: number) =>
        (cat.tags ?? []).filter(t => t.selected).map((tag: WorkPlaceTagFilter, index2: number) => (
          <span key={index + '.' + index2} className="wp-tag-filter hand"
            style={{ color: cat.faColor, backgroundColor: cat.bgColor }}
            onClick={() => onFilterDel(tag.tagId)}
          >
            <i className={cat.faIcon}></i> {tag.name}
          </span>
        ))
      )} */}

      {tagFilterSelected.map((tag: WorkPlaceTagFilter, index: number) => (
          <span key={index} className="wp-tag-filter hand"
            style={{ color: tag.faColor ?? "black", backgroundColor: tag.bgColor ?? "white" }}
            onClick={() => onFilterDel(tag.tagId)}
          >
            <i className={tag.faIcon ?? "fas fa-at"}></i> {tag.name}
          </span>

      ))}

      {/* <span className="erp-tag">ลวด GI</span>
      <span className="erp-tag">ลวดเชื่อม</span>
      <span className="erp-tag">ลวดผูกเหล็ก</span>
      <span className="erp-tag">ไวร์เมชแผง</span>
      <span className="erp-tag">เหล็กฉากกัลวาไนซ์</span>
      <span className="erp-tag">เหล็กปลอก</span>
      <span className="erp-tag">เหล็กรางรถไฟ</span> */}
    </div>
  );
}

export default WorkplaceFilterSel;